import { render, staticRenderFns } from "./AddParameter.vue?vue&type=template&id=386d0a42&scoped=true"
import script from "./AddParameter.vue?vue&type=script&lang=js"
export * from "./AddParameter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386d0a42",
  null
  
)

export default component.exports